import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-54a7a5fa"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "interactive-block-wrap" }
const _hoisted_2 = { class: "interactive-block" }
const _hoisted_3 = ["onMouseover"]
const _hoisted_4 = { class: "interactive-block-images" }
const _hoisted_5 = { class: "interactive-block-images-item" }
const _hoisted_6 = ["src"]

import {HelpModel, useLocalizationStore} from "@/shared";
import {computed, onMounted, ref} from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'interactive-block',
  props: {
  arrData: {
    type: Array<HelpModel>,
    default: Array<HelpModel>(),
  },
  smallp: {
    type: Boolean,
    default: false,
  },
},
  setup(__props) {

const props = __props;



const {translate} = useLocalizationStore();

onMounted(() => {
  if (props.arrData) getActiveItem.value = props.arrData[0];
});

const activeItem = ref<HelpModel>(new HelpModel());

const getActiveItem = computed({
  get: (): HelpModel => {
    return !activeItem.value ? props.arrData ? props.arrData[0] : null : activeItem.value;
  },
  set: (el: HelpModel) => {
    activeItem.value = el;
  },
});

const onOverItem = (item: HelpModel) => {
  activeItem.value = item;
};

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        class: _normalizeClass([{smallp:__props.smallp}, "interactive-block-texts"])
      }, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.arrData, (item, ind) => {
          return (_openBlock(), _createElementBlock("div", {
            key: ind,
            onMouseover: ($event: any) => (onOverItem(item))
          }, [
            _createElementVNode("div", {
              class: _normalizeClass([{'item-active':getActiveItem.value.Id==item.Id}, "interactive-block-texts-item"])
            }, [
              _createVNode(_component_router_link, {
                to: {name:item.Link, hash:item.ScrollHash},
                style: {"text-decoration":"none","color":"inherit"}
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(translate)(item.Text)), 1)
                ]),
                _: 2
              }, 1032, ["to"])
            ], 2)
          ], 40, _hoisted_3))
        }), 128))
      ], 2),
      _createElementVNode("div", _hoisted_4, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.arrData, (item, ind) => {
          return (_openBlock(), _createElementBlock("div", {
            key: ind,
            class: _normalizeClass({'item-active':getActiveItem.value.Id==item.Id})
          }, [
            _createElementVNode("div", _hoisted_5, [
              _withDirectives(_createElementVNode("img", {
                src: item.Image,
                alt: ""
              }, null, 8, _hoisted_6), [
                [_vShow, getActiveItem.value.Id==item.Id]
              ])
            ])
          ], 2))
        }), 128))
      ])
    ])
  ]))
}
}

})